import React from "react"
import { MainCP } from "../../Components/eleccienesDiciembre2023/MainCP"

const ViewEleccienesDiciembre2023: React.FC = () => <MainCP/>

export default ViewEleccienesDiciembre2023